

import {Component, Prop, Vue} from "vue-property-decorator";
import PazClipboardButton from "../../../components/controls/PazClipboardButton.vue";
import PazTooltipButton from "../../../components/controls/PazTooltipButton.vue";
import PazConfirmation from "../../../components/utils/PazConfirmation.vue";
import PazTextSearch from "../../../components/controls/PazTextSearch.vue";
import PazAjaxTable from "../../../components/layout/PazAjaxTable.vue";
import PazRefreshButton from "../../../components/controls/PazRefreshButton.vue";
import {deleteDocumentCategory, getRequiredDocumentCategory} from "../../../services/auth-service";
import {IApiCategoryStatusMask, IRequiredDocumentCategory} from "../../../models/dossier.model";
import {getDossieCategoryStatusMask} from "../../../services/dossier-service";
import EditCategoryDialog from "./EditCategoryDialog.vue";
import {DataTableHeader} from "vuetify";

@Component({
  components: {
    PazClipboardButton,
    EditCategoryDialog,
    PazTooltipButton,
    PazConfirmation,
    PazTextSearch,
    PazAjaxTable,
    PazRefreshButton,
  },
})
export default class RequiredCategoryOverview extends Vue {


  public loading: boolean = true;
  public showMaskInfo: boolean = false;
  @Prop({default: ''})
  public search!: string;
  public items: IRequiredDocumentCategory[] = [];
  public info: IApiCategoryStatusMask = {usesMasks: false, description: ''};

  public headers: DataTableHeader[] = [
    {
      text: "Sort index",
      align: "start",
      sortable: true,
      value: "sortindex",
    },
    {
      text: "Name",
      align: "start",
      sortable: true,
      value: "name",
    },
    {
      text: "Description",
      align: "start",
      sortable: true,
      value: "description",
    },
    {
      text: "statusMask",
      align: "start",
      sortable: true,
      value: "statusMask",
    },
    {
      text: "Action",
      align: "end",
      sortable: true,
      value: "extra",
    },
  ];
  showEditDialog: boolean = false;
  selectedId: number | null = null;


  $refs!: {
    confirm: PazConfirmation;
    response: PazConfirmation;
    confirmWarn: PazConfirmation;
  };


  async fetchData() {
    this.loading = true;
    this.items = await getRequiredDocumentCategory();
    this.info = await getDossieCategoryStatusMask();
    this.loading = false;
  }

  get collectMasks() {
    let rsp: Array<String> = [''];
    if (!this.info.usesMasks) {
      return rsp;
    }
    for (let mapKey in this.info.map) {
      this.info.map[mapKey].forEach((mask) => {
        if (!rsp.includes(mask)) {
          rsp.push(mask);
        }
      });
    }
    return rsp;
  }

  async confirmDeletion(group: any) {

    const confirm = await this.$refs.confirm.openConfirmDialog(
        "Delete",
        "Are you sure you want to delete `" + group.name + "`?"
    );
    if (confirm) {
      const response = await deleteDocumentCategory(group.id);
      if (response) await this.fetchData();
    }
  }

  triggerEditDialog(id: number | null) {
    this.selectedId = id;
    this.showEditDialog = true;
  }

  toggleMaskInfo() {
    this.showMaskInfo = !this.showMaskInfo;
  }

  async showDetails(id: number) {
    await this.$router.push({path: `/groups/${id}`})
  }

  public mounted() {
    this.fetchData();
  }
}
